import type { UseQueryOptions } from "@tanstack/react-query";
import { skipToken } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";
import usePersistedQuery from "$src/core/hooks/use-persisted-query";
import type { TranslationsDto } from "$src/core/models/dto";

const queryKey = () => ["translations"];

const useTranslationsQuery = (
  options?: Omit<
    UseQueryOptions<Awaited<TranslationsDto>>,
    "queryKey" | "queryFn"
  >,
) => {
  const { api } = useApi();

  return usePersistedQuery({
    queryKey: queryKey(),
    queryFn: api.getTranslations ? () => api.getTranslations!() : skipToken,
    ...options,
  });
};

export default useTranslationsQuery;
